import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5a6efbba"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "toolbar" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("Daily")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("Monthly")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("Total")
const _hoisted_5 = { class: "date-range" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "k-icon k-i-calendar" }, null, -1))
const _hoisted_7 = /*#__PURE__*/_createTextVNode("Apply")

import { computed, ref, onMounted } from "vue";
import { DateRangePicker as KDateRangePicker } from "@progress/kendo-vue-dateinputs";
import {
  Button as KButton,
  ButtonGroup as KButtonGroup,
} from "@progress/kendo-vue-buttons";
import {
  DateRange,
  ProductivityDataAggregate,
} from "@/core/types/dashboard/ProductivityData";

type Props = {
  dateRange: DateRange;
  selectedAggregate: ProductivityDataAggregate;
};


const __default__ = {
  name: "FiltersBar",
  inheritAttrs: false,
  customOptions: {},
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    dateRange: null,
    selectedAggregate: null
  },
  emits: [
  "aggregateChanged",
  "dateRangeChanged",
  "applyFilters",
],
  setup(__props: any, { emit: emits }) {

const props = __props as {
  dateRange: DateRange;
  selectedAggregate: ProductivityDataAggregate;
}




const selectedDateRange = ref({
  start: props.dateRange.start,
  end: props.dateRange.end,
});

const isDailyAggregate = computed(
  () => props.selectedAggregate == ProductivityDataAggregate.Daily,
);

const isMonthlyAggregate = computed(
  () => props.selectedAggregate == ProductivityDataAggregate.Monthly,
);

const isTotalAggregate = computed(
  () => props.selectedAggregate == ProductivityDataAggregate.Total,
);

onMounted(() => {
  selectedDateRange.value = props.dateRange;
});

const onAggregateChanged = (aggregate: ProductivityDataAggregate) => {
  emits("aggregateChanged", { selectedAggregate: aggregate });
};

const onDateRangeChanged = (event: any) => {
  selectedDateRange.value = event.value;
  if (event.value.start && event.value.end){
    // Emits only if the range is complete
    emits("dateRangeChanged", { selectedDataRange: event.value });
  }
};

const onApply = () => {
  emits("applyFilters");
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, [
      _createVNode(_unref(KButtonGroup), null, {
        default: _withCtx(() => [
          _createVNode(_unref(KButton), {
            class: _normalizeClass({ selected: _unref(isDailyAggregate) }),
            onClick: _cache[0] || (_cache[0] = ($event: any) => (onAggregateChanged(_unref(ProductivityDataAggregate).Daily)))
          }, {
            default: _withCtx(() => [
              _hoisted_2
            ]),
            _: 1
          }, 8, ["class"]),
          _createVNode(_unref(KButton), {
            class: _normalizeClass({ selected: _unref(isMonthlyAggregate) }),
            onClick: _cache[1] || (_cache[1] = ($event: any) => (onAggregateChanged(_unref(ProductivityDataAggregate).Monthly)))
          }, {
            default: _withCtx(() => [
              _hoisted_3
            ]),
            _: 1
          }, 8, ["class"]),
          _createVNode(_unref(KButton), {
            class: _normalizeClass({ selected: _unref(isTotalAggregate) }),
            onClick: _cache[2] || (_cache[2] = ($event: any) => (onAggregateChanged(_unref(ProductivityDataAggregate).Total)))
          }, {
            default: _withCtx(() => [
              _hoisted_4
            ]),
            _: 1
          }, 8, ["class"])
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_5, [
      _hoisted_6,
      _createVNode(_unref(KDateRangePicker), {
        value: selectedDateRange.value,
        format: 'd MMM yyyy',
        onChange: onDateRangeChanged
      }, null, 8, ["value"])
    ]),
    _createElementVNode("div", null, [
      _createVNode(_unref(KButton), {
        class: "apply-btn",
        onClick: onApply
      }, {
        default: _withCtx(() => [
          _hoisted_7
        ]),
        _: 1
      })
    ])
  ]))
}
}

})